import { Injectable } from '@angular/core';
import { cloneDeep, isEmpty } from 'lodash';
import { Project } from '../shared/interfaces/customer.interface';
import { usesCompanyAsDisplayName } from '../shared/utils/util-function';

@Injectable({
  providedIn: 'root'
})
export class ProjectReportService {

  customerList: any;
  constructor() { }

   mapProjectCustomerName(x: Project,appendProjectType: boolean = false) {
  
    x.DisplayName = x?.Name;
    if(!isEmpty(x.Customer)){
      x = this.mapProjectCustomer(x,appendProjectType);
    }
    return x.DisplayName;
    }
  
   mapProjectCustomer(x: Project, appendProjectType: boolean = false) {
    if (x.Customer) {
      x.Customer = cloneDeep(x.Customer);
      x.Customer.FirstName = x.Customer.FirstName == null ? '' : x.Customer.FirstName;
      x.Customer.LastName = x.Customer.LastName == null ? '' : x.Customer.LastName;
      x.Customer.Emails = x.Customer.Emails === undefined || x.Customer.Emails === null ? [] : x.Customer.Emails;
      x.Customer.PhoneNumbers = x.Customer.PhoneNumbers === undefined || x.Customer.PhoneNumbers === null ? [] : x.Customer.PhoneNumbers;
      let projectDisplayName = '';
      if (!x.Name) {
        const companyName = (x.Customer.CompanyName || '').trim();
        if (usesCompanyAsDisplayName(x.Customer.DisplayCompanyName, companyName)) {
          projectDisplayName = companyName + ' ' + `(${x.Customer.FirstName + (x.Customer.LastName ? ' ' + x.Customer.LastName : '')})`;
        } else if (companyName) {
          projectDisplayName = x.Customer.FirstName + ' ' + x.Customer.LastName + ' ' + `(${companyName})`;
        } else {
          projectDisplayName = (x.Customer.FirstName == '' && x.Customer.LastName == '') ? (x.Customer.Emails.length > 0 ? x.Customer.Emails[0].Email : '') : (x.Customer.FirstName + ' ' + x.Customer.LastName);
        }
      } else {
        projectDisplayName = x.Name;
      }
      x.DisplayName = projectDisplayName + ((appendProjectType && (x.ProjectType?.Name || '').length ? (" - " + (x.ProjectType?.Name || '')) : '') || '');
    }
    return x;
  }
}

